import { cn } from '../../lib/utils'

export default function Section({
  children,
  className,
  container = true,
  padding = 'default',
  background = 'white',
  ...props
}) {
  const paddingStyles = {
    small: 'section-padding-sm',
    default: 'section-padding',
    large: 'py-24 md:py-32 lg:py-40',
    none: ''
  }

  const backgroundStyles = {
    white: 'bg-dark-900',
    gray: 'bg-dark-800',
    'gradient': 'bg-gradient-to-br from-dark-900 via-dark-800 to-dark-900',
    teal: 'bg-gradient-to-br from-neon-lime/10 via-dark-900 to-neon-pink/10',
    navy: 'bg-gradient-to-br from-neon-purple/10 via-dark-900 to-neon-orange/10',
    dark: 'bg-dark-900'
  }

  return (
    <section
      className={cn(paddingStyles[padding], backgroundStyles[background], className)}
      {...props}
    >
      {container ? (
        <div className="container-custom">
          {children}
        </div>
      ) : children}
    </section>
  )
}
